import { getAllPosts } from './blog';

const MAX_RECENT = 3;

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('posts-list');
    if (!container) return;

    const posts = getAllPosts().slice(0, MAX_RECENT);

    if (posts.length === 0) {
        container.innerHTML = '<p>No posts yet. Check back soon!</p>';
        return;
    }

    container.innerHTML = posts
        .map(
            (post) => `
        <article class="post-card">
            <span class="post-date">${post.date}</span>
            <span class="post-title"><a href="/blog/${post.slug}/">link</a></span>
            ${post.html}
        </article>
    `
        )
        .join('');
});
